import { createRoute, Link } from "@tanstack/react-router";
import { PageHeader } from "@/components/kb/page-header";
import { RuleEditor } from "@/components/kb/rule-editor";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { useRules } from "@/hooks/useRules";
import { rootRoute } from "./__root";

export function EditRuleComponent() {
	const { ruleId } = editRuleRoute.useParams();
	const { data, isLoading, error } = useRules();

	if (isLoading) {
		return (
			<div className="flex flex-col gap-6">
				<Skeleton className="h-10 w-2/3" />
				<Skeleton className="h-40 w-full rounded-xl" />
				<Skeleton className="h-96 w-full rounded-xl" />
			</div>
		);
	}

	if (error) {
		return (
			<div className="flex flex-col gap-8">
				<PageHeader title="Edit rule" />
				<div className="rounded-xl border border-destructive/30 bg-destructive/5 p-5 text-sm text-destructive">
					Couldn&rsquo;t load rule: {error.message}
				</div>
			</div>
		);
	}

	const rule = data?.rules?.find((item) => item.id === ruleId);

	if (!rule) {
		return (
			<div className="flex flex-col items-center gap-4 rounded-xl border border-dashed px-6 py-16 text-center">
				<p className="font-medium">Rule not found.</p>
				<Button asChild variant="ghost">
					<Link to="/rules">Back to rules</Link>
				</Button>
			</div>
		);
	}

	return <RuleEditor key={rule.id} rule={rule} />;
}

export const editRuleRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/rules/edit/$ruleId",
	component: EditRuleComponent,
});
